<div *ngIf="checkIfOnIOS()">
    <hr>
    <div class="wrapper" *transloco="let translate">
      <h3>{{translate('mobileLauncher.modal_open_in_app')}}</h3>
      <div>
        <aero-button [size]="buttonSize"
                     (click)="openIOSApp()"
                     label="{{translate('mobileLauncher.modal_open_in_app')}}">
        </aero-button>
      </div>
    </div>
</div>

